import {initTrackableWidgets} from "./init";
import {BrandhubBackground} from './brandhub_background';
import {CliplisterVideo} from "./cliplister-video";
import {ConnectFour} from "./connect_four";
import {otto} from "@otto-ec/global-resources/nexus";

otto.ft3.promo.staticcontent.assignNamespace({
    brandhub_background: {
        init: () => {
            new BrandhubBackground();
        }
    },
    link: {
        init: () => {
            initTrackableWidgets()
        }
    },
    picture_info_card: {
        init: () => {
            initTrackableWidgets()
        }
    },
    video: {
        init: () => {
            initTrackableWidgets()
            new CliplisterVideo()
        }
    },
    connect_four: {
        init: () => {
            const connectFour = new ConnectFour();
            connectFour.init();
        }
    }
})
